import React from 'react';
import { Page } from '../../layout';
import { useTabExistCheck } from '../../shared/hooks/useTabExistCheck';
import useUriFragment from '../../shared/hooks/useUriFragment';
import { getActiveTabDisplayName } from '../../shared/services/getActiveTabDisplayNameService';
import { AppraisalDataDownload } from './AppraisalDataDownload';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import ResponsiveTabMenu from '../../shared/components/ResponsiveTabMenu';
import { CheckPointDataDownload } from './CheckPointDataDownload';
import { EventCommentDataDownload } from './EventCommentDataDownload';

const TAB_VALUES = {
  AppraisalData: 'appraisal-data-download',
  CheckPointData: 'check-point-data-download',
  EventComments: 'event-comments'
};

const TABS = [
  { value: TAB_VALUES.AppraisalData, displayName: 'Appraisal Data' },
  { value: TAB_VALUES.CheckPointData, displayName: 'Check Point Data' },
  { value: TAB_VALUES.EventComments, displayName: 'Event Comments' }
];

export const DataDownloadPage = () => {
  const [activeTab, setActiveTab] = useUriFragment(TABS);
  useTabExistCheck(TABS, activeTab);
  const activeTabDisplayName = getActiveTabDisplayName(TABS, activeTab);

  const breadcrumbPathItems = [
    { name: 'Data Download', url: '/data-download' },
    { name: activeTabDisplayName, url: '' }
  ];

  const handleTabChange = type => {
    setActiveTab(type);
  };

  const renderActiveTab = activeTab => {
    switch (activeTab) {
      case TAB_VALUES.AppraisalData:
        return <AppraisalDataDownload />;
      case TAB_VALUES.CheckPointData:
        return <CheckPointDataDownload />;
      case TAB_VALUES.EventComments:
        return <EventCommentDataDownload />;
      default:
        return '';
    }
  };

  return (
    <Page title={activeTabDisplayName} className='data-download-page'>
      <Breadcrumb pathItems={breadcrumbPathItems} />
      <ResponsiveTabMenu
        activeTab={activeTab}
        tabs={TABS}
        onChange={newType => handleTabChange(newType)}
      />
      {renderActiveTab(activeTab)}
    </Page>
  );
};
